const trainControllers = angular.module('trainControllers', ['ui.router']);

trainControllers.controller('trainController', function(
  $scope,
  $stateParams,
  trainService,
  gridletService,
  userViewService,
  eventService,
  $state,
) {
  let lastLoad;
  const emu = $stateParams.emu;
  $scope.view = 'trains';
  userViewService.setView('trains');
  $scope.customizable = gridletService.getCustomizable();
  $scope.train = null;

  $scope.loadTrain = function() {
    trainService.get(emu).then(function(data) {
      if (!angular.equals($scope.train, data)) {
        $scope.train = data;
        lastLoad = DateTime.now();
      }
      data = null;
    });
  };
  lastLoad = DateTime.now();
  const cancelUpdateEventListener = eventService.on('FLEET_STATUS', function () {
    if (lastLoad.diffNow('seconds').seconds < -3) {
      $scope.loadTrain();
    }
  });

  $scope.goBack = function() {
    $state.go(userViewService.getPreviousView());
  };

  $scope.$on('$destroy', function() {
    cancelUpdateEventListener();
  });

  $scope.$on('update-gridlet-list', function() {
    const forceReload = false;
    gridletService.getGridlets($scope.view, forceReload).then(function(gridlets) {
      $scope.availableGridlets = gridlets;
    });
  });

  const unbindTrainControllerListener = eventService.on(
    'toggle-customization',
    function (event, args) {
      $scope.customizable = args.customize;
    }
  );
  $scope.$on('$destroy', unbindTrainControllerListener);

  eventService.on('reset-widgets', function() {
    $scope.$broadcast('update-gridlet-list');
  });

  eventService.on('add-gridlet', function(event, args) {
    gridletService.showGridlet($scope.view, args.gridletId);
    $scope.$broadcast('update-gridlet-list');
  });

  $scope.hasNoConnection = function() {
    const train = $scope.train;
    return (
      (train && (train.accessTech !== 1 && train.accessTech !== 2)) ||
      !train ||
      train.status === 0
    );
  };

  $scope.hasMobileConnection = function() {
    const train = $scope.train;
    return train && train.accessTech === 1 && train.status !== 0;
  };

  $scope.hasWifiConnection = function() {
    const train = $scope.train;
    return train && train.accessTech === 2 && train.status !== 0;
  };

  $scope.loadTrain();
});
